'use client';
import { useState, useEffect, useRef } from 'react';
import s from './Button.module.scss';
import LocalizedLink from '@/app/components/LocalizedLink';
import { useModal } from '@/context/ModalContext';
import LinkButton from '@/app/components/ui/buttons/LinkButton/LinkButton';

const Button = ({
  children,
  variant = 'primary',
  disabled = false,
  onClick,
  className,
  isOpenModalButton,
  type,
  secondaryLayerColor,
  dataFields,
  page,
  externalUrl,
  openInNewTab,
  href,
}) => {
  let slug = page?.slug ? page?.slug : page;

  if (!href) {
    href = slug ? `/${slug}` : externalUrl;
  }

  const Component = href ? LocalizedLink : 'button';
  const [isHovered, setIsHovered] = useState(false);
  const secondaryLayerRef = useRef(null);
  const { openModal } = useModal();

  useEffect(() => {
    if (!secondaryLayerRef.current || disabled || isHovered) return;

    const element = secondaryLayerRef.current;
    const onTransitionEnd = () => {
      setIsHovered(false);
    };

    element.addEventListener('transitionend', onTransitionEnd);
    return () => element.removeEventListener('transitionend', onTransitionEnd);
  }, [isHovered, disabled]);

  const handleButtonClick = (event) => {
    if (onClick) {
      onClick(event);
    }
    if (isOpenModalButton) {
      openModal(isOpenModalButton, dataFields);
    }
  };

  const attributes = {};

  if (type) {
    attributes.type = type;
  }

  if (href) {
    attributes.href = href;
  }

  if (openInNewTab) {
    attributes.target = '_blank';
    attributes.rel = 'noopener noreferrer';
  }

  return variant !== 'underlined' ? (
    <Component
      {...attributes}
      className={`${className} ${s.button} ${s[variant ? variant : 'primary']} ${disabled ? s.disabled : ''}`}
      disabled={disabled}
      onClick={handleButtonClick}
      onMouseEnter={() => !disabled && setIsHovered(true)}
    >
      <span className={`${s.primaryText} ${s.buttonContent}`}>{children}</span>

      <span
        className={`${s.secondaryLayer} ${s[secondaryLayerColor]}`}
        ref={secondaryLayerRef}
      >
        {isHovered && (
          // <Magnetic power={0.1} disabled={!isHovered || disabled}>
          <span className={s.magneticWrapper}>
            <span className={`${s.secondaryText} ${s.buttonContent}`}>
              {children}
            </span>
          </span>
          // </Magnetic>
        )}

        <span className={`${s.background}`}></span>
      </span>
    </Component>
  ) : (
    <LinkButton
      href={href}
      children={children}
      onClick={handleButtonClick}
      className={className}
      variant={variant}
    />
  );
};

export default Button;
